import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'meg-about-app',
  templateUrl: './about-app.component.html',
  styleUrls: ['./about-app.component.css']
})
export class AboutAppComponent implements OnInit {
  constructor() { }

  ngOnInit() {}
}
